import { getJWT, getLocal, getLocalId } from '../Utils/Profile'
import { BASEAPI, BASEAMIPOSAPI } from './constants'

const processPaymentOrder = async (
    storeId: string,
    idVenta: string,
    data: any
) => {
    const res = await fetch(
        `${BASEAPI}amipos-back/locales/${storeId}/ventas/${idVenta}/pagar`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return [data, response.status]
        })
        .catch((error) => {
            console.error(error)
            return null
        })
    return res
}

const processPaymentOrderV2 = async (
    storeId: string,
    idVenta: string,
    data: any
) => {
    const res = await fetch(
        `${BASEAPI}locales/${storeId}/ventas/${idVenta}/pagar`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return [data, response.status]
        })
        .catch((error) => {
            console.error(error)
            return null
        })
    return res
}
const createPaymentOrder = async (idLocal: string, data: any) => {
    const res = await fetch(`${BASEAPI}locales/${idLocal}/ventas`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
        body: JSON.stringify(data),
    })
        .then(async (response) => {
            const data = JSON.parse(await response.text())

            return [data, response.status]
        })
        .catch((error) => {
            console.error(error)
            alert('Hubo un error al crear la orden de pago')
            return null
        })
    return res
}

const processBciPayment = async (storeID: string, data: any) => {
    const res = await fetch(`${BASEAPI}amipos-back/pay/bci/store/${storeID}`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
        body: JSON.stringify(data),
    })
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return { ...data, status: response.status }
        })
        .catch((error) => {
            console.error('AAAA', error.message, error.stacktrace)
            return null
        })
    return res
}

const getProcessedBciPayment = async (orderId: any) => {
    const res = await fetch(`${BASEAPI}amipos-back/pay/bci/${orderId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    }).then(async (response) => {
        return JSON.parse(await response.text())
    })
    return res
}

const reverseBciPayment = async (transactionID: string) => {
    const res = await fetch(`${BASEAPI}amipos-back/pay/bci/${transactionID}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    })
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return data
        })
        .catch((error) => {
            console.error('Error al anular la transacción BCI:', error.message)
            return null
        })

    return res
}
const processGetnetPayment = async (storeID: string, data: any) => {
    const res = await fetch(
        `${BASEAPI}amipos-back/pay/getnetc2c/store/${storeID}`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return { ...data, status: response.status }
        })
        .catch((error) => {
            console.error(
                'processGetnetPayment Error',
                error.message,
                error.stacktrace
            )
            return null
        })
    return res
}

const getProcessedGetnetPayment = async (orderId: any) => {
    const res = await fetch(`${BASEAPI}amipos-back/pay/getnetc2c/${orderId}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    }).then(async (response) => {
        return JSON.parse(await response.text())
    })
    return res
}

const reverseGetnetPayment = async (transactionID: string) => {
    const res = await fetch(
        `${BASEAPI}amipos-back/pay/getnetc2c/${transactionID}`,
        {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return data
        })
        .catch((error) => {
            console.error(
                'Error al anular la transacción Getnet:',
                error.message
            )
            return null
        })

    return res
}

//END
const anularVenta = async (id: string) => {
    const user = localStorage.getItem('currentUser')
    const userData: ICommerceBO = user ? JSON.parse(user) : null

    const res = await fetch(
        `${BASEAPI}locales/${getLocalId()}/ventas/${id}/anular`,
        {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify({
                idTransaccion: id,
                sLocal: getLocal(),
                sEstablecimiento: userData.sEstablecimiento,
            }),
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return { ...data, status: 'TX_NULLED' }
        })
        .catch(() => {
            return null
        })

    return res
}

const processPOSManualPayment = async (storeID: string, data: any) => {
    const res = await fetch(
        `${BASEAMIPOSAPI}locales/${storeID}/ventas/pos/pagar`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return { ...data, status: response.status }
        })
        .catch((error) => {
            console.error('AAAA', error.message, error.stacktrace)
            return null
        })
    return res
}

const processCashPayment = async (storeID: string, data: any) => {
    const res = await fetch(
        `${BASEAMIPOSAPI}locales/${storeID}/ventas/cash/pagar`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify(data),
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return { ...data, status: response.status }
        })
        .catch((error) => {
            console.error('AAAA', error.message, error.stacktrace)
            return null
        })
    return res
}

const reverseCashPayment = async (
    storeID: string,
    idVenta: string,
    nMonto: number
) => {
    const res = await fetch(
        `${BASEAMIPOSAPI}locales/${storeID}/ventas/cash/anular`,
        {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify({
                idTransaccion: parseInt(idVenta),
                nMonto: Number(nMonto),
            }),
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return { ...data, status: response.status }
        })
        .catch((error) => {
            console.error('AAAA', error.message, error.stacktrace)
            return null
        })

    return res
}

const reversePOSManualPayment = async (
    storeID: string,
    idVenta: string,
    nMonto: number
) => {
    const res = await fetch(
        `${BASEAMIPOSAPI}locales/${storeID}/ventas/pos/anular`,
        {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
            body: JSON.stringify({
                idTransaccion: parseInt(idVenta),
                nMonto: Number(nMonto),
            }),
        }
    )
        .then(async (response) => {
            const data = JSON.parse(await response.text())
            return { ...data, status: response.status }
        })
        .catch((error) => {
            console.error('AAAA', error.message, error.stacktrace)
            return null
        })

    return res
}

export {
    processPaymentOrder,
    createPaymentOrder,
    processBciPayment,
    getProcessedBciPayment,
    processGetnetPayment,
    getProcessedGetnetPayment,
    processPaymentOrderV2,
    reverseBciPayment,
    reverseGetnetPayment,
    anularVenta,
    processCashPayment,
    reverseCashPayment,
    processPOSManualPayment,
    reversePOSManualPayment,
}
